import React from "react";
import * as firebase from "firebase/app";
import Menu from "@material-ui/core/Menu";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import ArrowDropDownSharpIcon from "@material-ui/icons/ArrowDropDownSharp";
import UserIcon from "@material-ui/icons/AccountCircleOutlined";
// import { useStore, debugChangeUser } from "../Store";

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  color: {
    color: "white",
  },
  icon: {
    color: "white",
    marginRight: theme.spacing(1),
  },
}));

interface Props {
  user: firebase.User;
  signOut: () => void;
}

const UserProfileDropdown: React.FC<Props> = ({ user, signOut }) => {
  const classes = useStyle();
  // const { state, dispatch } = useStore();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // const sudoTo = (e: string) => {
  //   dispatch(debugChangeUser(e));
  //   setAnchorEl(null);
  // };

  // Where possible, we'll use the user information stored in store/redux instead,
  // so we allow for more fun dynamic features.
  // Just so you know that the one from firebase is the actual user, the one
  // from redux is the impersonated user.

  // console.log(state);
  return (
    <>
      <Button onClick={handleClick} id="MenuButton">
        <UserIcon className={classes.icon} />
        <p className={classes.color}>{user.email}</p>
        <ArrowDropDownSharpIcon className={classes.color} />
      </Button>
      <Paper>
        <Menu
          elevation={0}
          getContentAnchorEl={null}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <MenuList>
            {/* <MenuItem>
              <Typography variant="button">{state.userinfo?.name}</Typography>
            </MenuItem>
            <MenuItem>
              <Typography variant="button">{user.phoneNumber}</Typography>
            </MenuItem>
            {state.featureflags?.debug && (
              <MenuItem
                onClick={() => {
                  sudoTo("");
                }}
              >
                <Typography variant="button">Debug: reset sudo</Typography>
              </MenuItem>
            )}
            {state.featureflags?.debug && (
              <MenuItem
                onClick={() => {
                  sudoTo("amil@tuxuri.com");
                }}
              >
                <Typography variant="button">Debug: amil@tuxuri.com</Typography>
              </MenuItem>
            )}
            {state.featureflags?.debug && (
              <MenuItem
                onClick={() => {
                  sudoTo("lembaga@tuxuri.com");
                }}
              >
                <Typography variant="button">
                  Debug: lembaga@tuxuri.com
                </Typography>
              </MenuItem>
            )}
            {state.featureflags?.debug && (
              <MenuItem
                onClick={() => {
                  sudoTo("lzs");
                }}
              >
                <Typography variant="button">Debug: lzs</Typography>
              </MenuItem>
            )}
            {state.featureflags?.debug && (
              <MenuItem
                onClick={() => {
                  sudoTo("tuxgeozakat");
                }}
              >
                <Typography variant="button">Debug: tuxgeozakat</Typography>
              </MenuItem>
            )} */}

            <MenuItem onClick={signOut}>
              <Typography variant="button">Log Keluar</Typography>
            </MenuItem>
          </MenuList>
        </Menu>
      </Paper>
    </>
  );
};

export default UserProfileDropdown;
